/**
 * YEŞİLKÖŞE KAFE - HYBRID STORE WITH HD UN SPLASH IMAGES & REALTIME CLOUD
 */

import {
  supabase,
  isCloudConnected,
  fetchCloudEventRequests,
  saveCloudEventRequest,
  updateCloudEventRequestStatus,
  deleteCloudEventRequest,
  fetchCloudTableCalls,
  saveCloudTableCall,
  deleteCloudTableCall,
  fetchCloudAdisyons,
  saveCloudAdisyon,
  deleteCloudAdisyon,
  subscribeRealtimeEvents,
  sendTelegramNotification,
  fetchCloudProducts,
  upsertCloudProduct,
  deleteCloudProduct,
  fetchCloudCategories,
  upsertCloudCategory,
  deleteCloudCategory,
  fetchCloudTables,
  upsertCloudTable,
  deleteCloudTable,
  fetchCloudAreas,
  upsertCloudArea
} from './supabaseClient.js';

const DEFAULT_AREAS = [
  { id: 'ic-mekan', name: 'İç Mekan', icon: 'ri-building-line' },
  { id: 'dis-ust-mekan', name: 'Dış Üst Mekan', icon: 'ri-sun-line' },
  { id: 'dis-alt-mekan', name: 'Dış Alt Mekan', icon: 'ri-tree-line' }
];

function generateSecureToken(prefix) {
  return `${prefix}_${Date.now().toString(36)}`;
}

const INITIAL_TABLES = [
  { id: "masa-1", name: "Masa 1", areaId: "ic-mekan", status: "empty", token: "m1_oxxvcj" },
  { id: "masa-2", name: "Masa 2", areaId: "ic-mekan", status: "empty", token: "m2_tl5wsz" },
  { id: "masa-3", name: "Masa 3", areaId: "ic-mekan", status: "empty", token: "m3_lkjh35" },
  { id: "masa-4", name: "Masa 4", areaId: "ic-mekan", status: "empty", token: "m4_vrrptb" },
  { id: "masa-5", name: "Masa 5", areaId: "ic-mekan", status: "empty", token: "m5_jy1w6t" },
  { id: "masa-6", name: "Masa 6", areaId: "ic-mekan", status: "empty", token: "m6_p16p9g" },
  { id: "masa-7", name: "Masa 7", areaId: "ic-mekan", status: "empty", token: "m7_l7jhtl" },
  { id: "masa-8", name: "Masa 8", areaId: "ic-mekan", status: "empty", token: "m8_zp6h5i" },
  { id: "masa-9", name: "Masa 9", areaId: "ic-mekan", status: "empty", token: "m9_qhvu36" },
  { id: "masa-10", name: "Masa 10", areaId: "ic-mekan", status: "empty", token: "m10_2w9sa7" },
  { id: "masa-11", name: "Masa 11", areaId: "dis-ust-mekan", status: "empty", token: "m11_n8dl60" },
  { id: "masa-12", name: "Masa 12", areaId: "dis-ust-mekan", status: "empty", token: "m12_dmtl0f" },
  { id: "masa-13", name: "Masa 13", areaId: "dis-ust-mekan", status: "empty", token: "m13_d9lr8z" },
  { id: "masa-14", name: "Masa 14", areaId: "dis-ust-mekan", status: "empty", token: "m14_504kbh" },
  { id: "masa-15", name: "Masa 15", areaId: "dis-ust-mekan", status: "empty", token: "m15_wvdba4" },
  { id: "masa-16", name: "Masa 16", areaId: "dis-ust-mekan", status: "empty", token: "m16_f7j82q" },
  { id: "masa-17", name: "Masa 17", areaId: "dis-ust-mekan", status: "empty", token: "m17_v4ejlf" },
  { id: "masa-18", name: "Masa 18", areaId: "dis-ust-mekan", status: "empty", token: "m18_7zqtpn" },
  { id: "masa-19", name: "Masa 19", areaId: "dis-ust-mekan", status: "empty", token: "m19_5ar0rx" },
  { id: "masa-20", name: "Masa 20", areaId: "dis-ust-mekan", status: "empty", token: "m20_159h4r" },
  { id: "masa-21", name: "Masa 21", areaId: "dis-alt-mekan", status: "empty", token: "m21_r7acmy" },
  { id: "masa-22", name: "Masa 22", areaId: "dis-alt-mekan", status: "empty", token: "m22_3mdnxx" },
  { id: "masa-23", name: "Masa 23", areaId: "dis-alt-mekan", status: "empty", token: "m23_e6d7kc" },
  { id: "masa-24", name: "Masa 24", areaId: "dis-alt-mekan", status: "empty", token: "m24_fmajxm" },
  { id: "masa-25", name: "Masa 25", areaId: "dis-alt-mekan", status: "empty", token: "m25_ztnlpu" },
  { id: "masa-26", name: "Masa 26", areaId: "dis-alt-mekan", status: "empty", token: "m26_k57f2t" },
  { id: "masa-27", name: "Masa 27", areaId: "dis-alt-mekan", status: "empty", token: "m27_tihhzo" },
  { id: "masa-28", name: "Masa 28", areaId: "dis-alt-mekan", status: "empty", token: "m28_5hleq3" },
  { id: "masa-29", name: "Masa 29", areaId: "dis-alt-mekan", status: "empty", token: "m29_7wc8sf" },
  { id: "masa-30", name: "Masa 30", areaId: "dis-alt-mekan", status: "empty", token: "m30_r71m2k" }
];


export const INITIAL_PRODUCTS = [
  // --- SICAK İÇECEKLER ---
  {
    id: 'demleme-cay',
    name: 'Demleme Bardak Çay',
    category: 'Sıcak İçecekler',
    price: 35,
    tags: ['Geleneksel'],
    desc: 'Taze demlenmiş, berrak geleneksel Türk çayı.',
    imageUrl: 'https://images.unsplash.com/photo-1576092768241-dec231879fc3?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1576092768241-dec231879fc3?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'demlik-cay',
    name: 'Demlik Çay',
    category: 'Sıcak İçecekler',
    price: 180,
    tags: ['Paylaşımlı'],
    desc: 'Kalabalık masalar için özel sıcak servis edilen demlik çay.',
    imageUrl: 'https://images.unsplash.com/photo-1597481499750-3e6b22637e12?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1597481499750-3e6b22637e12?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'semaver-cay',
    name: 'Semaver Çay',
    category: 'Sıcak İçecekler',
    price: 320,
    tags: ['Açık Hava Özel'],
    desc: 'Açık alan ve sohbet keyfi için köz tadında semaver çayı.',
    imageUrl: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'turk-kahvesi',
    name: 'Türk Kahvesi',
    category: 'Sıcak İçecekler',
    price: 75,
    tags: ['Geleneksel'],
    desc: 'Bol köpüklü, yanında lokum ve su ile geleneksel servis.',
    imageUrl: 'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'dibek-kahvesi',
    name: 'Klasik Dibek Kahvesi',
    category: 'Sıcak İçecekler',
    price: 85,
    tags: ['Yumuşak İçim'],
    desc: 'Taş dibekte dövülmüş, yumuşak içimli aromatik kahve.',
    imageUrl: 'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'damla-sakizli-dibek',
    name: 'Damla Sakızlı Dibek Kahvesi',
    category: 'Sıcak İçecekler',
    price: 95,
    tags: ['Aromatik'],
    desc: "Ege'nin ferahlatıcı damla sakızı aromalı dibek kahvesi.",
    imageUrl: 'https://images.unsplash.com/photo-1517256064527-09c73fc73e38?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1517256064527-09c73fc73e38?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'findikli-dibek',
    name: 'Fındıklı Dibek Kahvesi',
    category: 'Sıcak İçecekler',
    price: 95,
    tags: ['Özel Lezzet'],
    desc: 'Çifte kavrulmuş fındık notalı dibek kahvesi.',
    imageUrl: 'https://images.unsplash.com/photo-1534778101976-62847782c213?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1534778101976-62847782c213?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'osmanli-dibek',
    name: 'Osmanlı Dibek Kahvesi',
    category: 'Sıcak İçecekler',
    price: 95,
    tags: ['Zengin İçerik'],
    desc: 'Baharat ve sahlep aromalı saray tarifi.',
    imageUrl: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'menengic-kahvesi',
    name: 'Menengiç Kahvesi',
    category: 'Sıcak İçecekler',
    price: 90,
    tags: ['Kafeinsiz'],
    desc: 'Kafeinsiz ve sütlü özel çitlembik lezzeti.',
    imageUrl: 'https://images.unsplash.com/photo-1579992357154-faf4bde95b3d?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1579992357154-faf4bde95b3d?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'espresso',
    name: 'Espresso',
    category: 'Sıcak İçecekler',
    price: 80,
    tags: ['Yoğun'],
    desc: '%100 Arabica çekirdeklerinden yoğun İtalyan kahvesi.',
    imageUrl: 'https://images.unsplash.com/photo-1510591509098-f4fdc6d0ff04?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1510591509098-f4fdc6d0ff04?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'americano',
    name: 'Americano',
    category: 'Sıcak İçecekler',
    price: 95,
    tags: ['Klasik'],
    desc: "Espresso'nun sıcak su ile yumuşatılmış dengeli hali.",
    imageUrl: 'https://images.unsplash.com/photo-1551030173-122aabc4489c?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1551030173-122aabc4489c?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'latte',
    name: 'Caffè Latte',
    category: 'Sıcak İçecekler',
    price: 110,
    tags: ['Sütlü'],
    desc: 'Espresso ile kadifemsi sütün mükemmel uyumu.',
    imageUrl: 'https://images.unsplash.com/photo-1534778101976-62847782c213?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1534778101976-62847782c213?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: {
      title: 'Şurup Seçeneği',
      choices: ['Sade', 'Fındık Şurubu', 'Karamel Şurubu', 'Vanilya Şurubu']
    }
  },
  {
    id: 'nescafe',
    name: 'Nescafe (Sütlü / Sade)',
    category: 'Sıcak İçecekler',
    price: 70,
    tags: ['Klasik'],
    desc: 'Pratik ve yumuşak içimli sıcak kahve.',
    imageUrl: 'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'bitki-caylari',
    name: 'Bitki Çayları',
    category: 'Sıcak İçecekler',
    price: 85,
    tags: ['Doğal'],
    desc: 'Porselen fincanda taze demlenen şifalı çaylar.',
    imageUrl: 'https://images.unsplash.com/photo-1597481499750-3e6b22637e12?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1597481499750-3e6b22637e12?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: {
      title: 'Çeşit Seçiniz',
      choices: ['Ihlamur', 'Adaçayı', 'Yeşil Çay', 'Papatya', 'Kış Çayı']
    }
  },
  {
    id: 'oralet',
    name: 'Meyveli Oralet',
    category: 'Sıcak İçecekler',
    price: 45,
    tags: ['Nostaljik'],
    desc: 'Sıcak ve tatlı meyve aromalı içecek.',
    imageUrl: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: {
      title: 'Aroma Seçiniz',
      choices: ['Portakal', 'Kuşburnu', 'Limon', 'Vişne']
    }
  },
  {
    id: 'sicak-cikolata',
    name: 'Sıcak Çikolata',
    category: 'Sıcak İçecekler',
    price: 115,
    tags: ['Tatlı'],
    desc: 'Yoğun çikolata kıvamı ve süt köpüğüyle tatlı mola.',
    imageUrl: 'https://images.unsplash.com/photo-1542990253-0d0f5be5f0ed?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1542990253-0d0f5be5f0ed?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'sahlep',
    name: 'Geleneksel Sahlep',
    category: 'Sıcak İçecekler',
    price: 120,
    tags: ['Geleneksel'],
    desc: 'Üzeri bol tarçınlı taze sahlep.',
    imageUrl: 'https://images.unsplash.com/photo-1541167760496-1628856ab772?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1541167760496-1628856ab772?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },

  // --- SOĞUK İÇECEKLER ---
  {
    id: 'kutu-kola',
    name: 'Kutu Kola',
    category: 'Soğuk İçecekler',
    price: 65,
    tags: ['Meşrubat'],
    desc: 'Buz gibi serinletici gazlı içecek.',
    imageUrl: 'https://images.unsplash.com/photo-1622483767028-3f66f32aef97?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1622483767028-3f66f32aef97?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: {
      title: 'Çeşit Seçiniz',
      choices: ['Klasik', 'Zero / Şekersiz']
    }
  },
  {
    id: 'fanta',
    name: 'Fanta',
    category: 'Soğuk İçecekler',
    price: 65,
    tags: ['Meşrubat'],
    desc: 'Portakal aromalı gazlı meşrubat.',
    imageUrl: 'https://images.unsplash.com/photo-1625772299848-391b6a87d7b3?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1625772299848-391b6a87d7b3?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'sprite',
    name: 'Sprite / Gazoz',
    category: 'Soğuk İçecekler',
    price: 65,
    tags: ['Meşrubat'],
    desc: 'Limon aromalı ferahlatıcı gazlı içecek.',
    imageUrl: 'https://images.unsplash.com/photo-1625772299848-391b6a87d7b3?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1625772299848-391b6a87d7b3?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'ice-tea',
    name: 'Soğuk Çay (Ice Tea)',
    category: 'Soğuk İçecekler',
    price: 70,
    tags: ['Ferahlatıcı'],
    desc: 'Ferahlatıcı meyve aromalı soğuk çay.',
    imageUrl: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: {
      title: 'Aroma Seçiniz',
      choices: ['Şeftali', 'Limon', 'Karpuz', 'Mango']
    }
  },
  {
    id: 'meyve-suyu',
    name: 'Meyve Suları',
    category: 'Soğuk İçecekler',
    price: 60,
    tags: ['Meyveli'],
    desc: 'Cam şişede lezzetli meyve suyu çeşitleri.',
    imageUrl: 'https://images.unsplash.com/photo-1613478223719-2ab802602423?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1613478223719-2ab802602423?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: {
      title: 'Çeşit Seçiniz',
      choices: ['Karışık', 'Vişne', 'Şeftali', 'Kayısı', 'Elma']
    }
  },
  {
    id: 'sade-soda',
    name: 'Maden Suyu (Sade Soda)',
    category: 'Soğuk İçecekler',
    price: 40,
    tags: ['Mineralli'],
    desc: 'Doğal mineralli ferahlatıcı sade maden suyu.',
    imageUrl: 'https://images.unsplash.com/photo-1548839140-29a749e1cf4e?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1548839140-29a749e1cf4e?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'meyveli-soda',
    name: 'Meyveli Maden Suyu',
    category: 'Soğuk İçecekler',
    price: 45,
    tags: ['Meyveli'],
    desc: 'Doğal meyve aromalı maden suyu.',
    imageUrl: 'https://images.unsplash.com/photo-1527661591475-527312dd65f5?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1527661591475-527312dd65f5?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: {
      title: 'Aroma Seçiniz',
      choices: ['Limon', 'Elma', 'Karpuz-Çilek', 'Narenciye']
    }
  },
  {
    id: 'churchill',
    name: 'Churchill',
    category: 'Soğuk İçecekler',
    price: 60,
    tags: ['Özel Karışım'],
    desc: 'Taze limon suyu, tuz ve maden suyunun buzlu karışımı.',
    imageUrl: 'https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'ayran',
    name: 'Köpüklü / Açık Ayran',
    category: 'Soğuk İçecekler',
    price: 45,
    tags: ['Geleneksel'],
    desc: 'Geleneksel yayık kıvamında soğuk ayran.',
    imageUrl: 'https://images.unsplash.com/photo-1576092768241-dec231879fc3?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1576092768241-dec231879fc3?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'salgam',
    name: 'Şalgam Suyu',
    category: 'Soğuk İçecekler',
    price: 45,
    tags: ['Geleneksel'],
    desc: 'Geleneksel lezzetinde soğuk şalgam suyu.',
    imageUrl: 'https://images.unsplash.com/photo-1546833999-b9f581a1996d?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1546833999-b9f581a1996d?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: {
      title: 'Acı Durumu',
      choices: ['Acısız', 'Acılı']
    }
  },
  {
    id: 'iced-americano',
    name: 'Iced Americano',
    category: 'Soğuk İçecekler',
    price: 105,
    tags: ['Soğuk Kahve'],
    desc: 'Espresso, soğuk su ve buzun ferahlatıcı birleşimi.',
    imageUrl: 'https://images.unsplash.com/photo-1517701604599-bb29b565090c?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1517701604599-bb29b565090c?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'iced-latte',
    name: 'Iced Latte',
    category: 'Soğuk İçecekler',
    price: 120,
    tags: ['Soğuk Kahve'],
    desc: 'Espresso, soğuk süt ve buz parçalarının kadifemsi uyumu.',
    imageUrl: 'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: {
      title: 'Şurup Seçeneği',
      choices: ['Sade', 'Fındık Şurubu', 'Karamel Şurubu', 'Vanilya Şurubu']
    }
  },
  {
    id: 'ev-yapimi-limonata',
    name: 'Ev Yapımı Limonata',
    category: 'Soğuk İçecekler',
    price: 90,
    tags: ['Ev Yapımı'],
    desc: 'Taze sıkılmış limon ve nane yapraklarıyla limonata.',
    imageUrl: 'https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'su',
    name: 'Ambalajlı Su',
    category: 'Soğuk İçecekler',
    price: 25,
    tags: ['Temel'],
    desc: 'Soğuk doğal kaynak suyu.',
    imageUrl: 'https://images.unsplash.com/photo-1548839140-29a749e1cf4e?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1548839140-29a749e1cf4e?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },

  // --- TATLILAR ---
  {
    id: 'fistikli-dilim-pasta',
    name: 'Fıstıklı Dilim Pasta',
    category: 'Tatlılar',
    price: 135,
    tags: ['Özel Lezzet', 'Günlük Taze'],
    desc: 'Antep fıstığı parçaları ve ipeksi kremasıyla hazırlanan taze dilim pasta.',
    imageUrl: 'https://images.unsplash.com/photo-1565958011703-44f9829ba187?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1565958011703-44f9829ba187?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'cilekli-dilim-pasta',
    name: 'Çilekli Dilim Pasta',
    category: 'Tatlılar',
    price: 135,
    tags: ['Favori', 'Günlük Taze'],
    desc: 'Taze çilek dilimleri ve hafif pasta kremasıyla hazırlanan nefis dilim pasta.',
    imageUrl: 'https://images.unsplash.com/photo-1565958011703-44f9829ba187?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1565958011703-44f9829ba187?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'muzlu-dilim-pasta',
    name: 'Muzlu Dilim Pasta',
    category: 'Tatlılar',
    price: 130,
    tags: ['Günlük Taze'],
    desc: 'Taze muz parçaları ve yumuşacık kek katmanlarıyla günlük taze pasta.',
    imageUrl: 'https://images.unsplash.com/photo-1535141192574-5d4897c13136?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1535141192574-5d4897c13136?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'cikolatali-dilim-pasta',
    name: 'Çikolatalı Dilim Pasta',
    category: 'Tatlılar',
    price: 135,
    tags: ['Çok Satan', 'Günlük Taze'],
    desc: 'Yoğun çikolatalı ganaj ve kadifemsi kek katmanlarıyla nefis çikolatalı pasta.',
    imageUrl: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'cheesecake',
    name: 'Cheesecake',
    category: 'Tatlılar',
    price: 140,
    tags: ['Taze'],
    desc: 'Kıvamlı özel kreması ve çıtır bisküvi tabanıyla taze hazırlanan nefis cheesecake.',
    imageUrl: 'https://images.unsplash.com/photo-1533134242443-d4fd215305ad?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1533134242443-d4fd215305ad?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: {
      title: 'Sos Seçiniz',
      choices: ['Limonlu', 'Frambuazlı']
    }
  },
  {
    id: 'magnolia',
    name: 'Magnolia',
    category: 'Tatlılar',
    price: 125,
    tags: ['Hafif Tatlı'],
    desc: 'İpeksi özel kreması, bisküvi kırıntıları ve taze meyve dilimleriyle sunulan hafif tatlı.',
    imageUrl: 'https://images.unsplash.com/photo-1488477181946-6428a0291777?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1488477181946-6428a0291777?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: {
      title: 'Meyve Seçiniz',
      choices: ['Çilekli', 'Muzlu']
    }
  },
  {
    id: 'saray-sarmasi',
    name: 'Geleneksel Saray Sarması',
    category: 'Tatlılar',
    price: 110,
    tags: ['Geleneksel', 'Sütlü Tatlı'],
    desc: 'Hindistan cevizi yatağında sarılmış, kadifemsi kıvamda hafif sütlü saray tatlısı.',
    imageUrl: 'https://images.unsplash.com/photo-1541783245831-57d6fb0926d3?auto=format&fit=crop&w=600&q=80',
    image: 'https://images.unsplash.com/photo-1541783245831-57d6fb0926d3?auto=format&fit=crop&w=600&q=80',
    isOutOfStock: false,
    options: null
  },

  // --- KAHVALTILIKLAR ---
  {
    id: 'serpme-kahvalti',
    name: 'Serpme Yeşilköşe Kahvaltısı',
    category: 'Kahvaltılıklar',
    price: 450,
    tags: ['2 Kişilik'],
    desc: 'Yöresel peynirler, bal-kaymak, sucuklu yumurta ve sınırsız çay.',
    imageUrl: './src/assets/images/hero-interior.jpg',
    image: './src/assets/images/hero-interior.jpg',
    isOutOfStock: false,
    options: null
  },
  {
    id: 'avokado-tost',
    name: 'Avokadolu & Poşe Yumurtalı Tost',
    category: 'Kahvaltılıklar',
    price: 195,
    tags: ['Diyet Dostu'],
    desc: 'Ekşi mayalı ekmek üzerine avokado ezmesi ve poşe yumurta.',
    imageUrl: './src/assets/images/hero-interior.jpg',
    image: './src/assets/images/hero-interior.jpg',
    isOutOfStock: false,
    options: null
  }
];

const INITIAL_EVENT_REQUESTS = [
  {
    id: 'req_101',
    fullName: 'Zeynep Yılmaz',
    phone: '0532 111 22 33',
    eventType: 'nisan',
    eventTypeName: 'Nişan / Kına Gecesi',
    date: '2026-09-15',
    guests: 120,
    notes: 'Açık bahçe alanında kır konsepti süsleme ve canlı müzik istiyoruz.',
    status: 'new',
    createdAt: '09.08.2026 01:15'
  },
  {
    id: 'req_102',
    fullName: 'Murat Şahin (ABC Teknoloji)',
    phone: '0505 444 55 66',
    eventType: 'kurumsal',
    eventTypeName: 'Kurumsal Etkinlik',
    date: '2026-10-02',
    guests: 80,
    notes: 'Şirket lansmanı ve kokteyl ikramı için VIP salon kiralaması.',
    status: 'contacted',
    createdAt: '08.08.2026 14:30'
  }
];

const INITIAL_ONLINE_ORDERS = [
  {
    id: 'ord_1001',
    orderType: 'delivery',
    customerName: 'Ahmet Yılmaz',
    phone: '0532 555 12 34',
    address: 'Alsancak Mah. 2205 Sk. No:14 D:3 Etimesgut/ANKARA',
    orderNote: 'Kapıyı çalmayın, güvenliğe bırakabilirsiniz.',
    paymentMethod: 'credit_card',
    paymentMethodName: 'Kapıda Kredi Kartı',
    items: [
      { id: 'demleme-cay', name: 'Demleme Bardak Çay', price: 35, qty: 2 },
      { id: 'san-sebastian', name: 'Eriyen Sıcak Çikolatalı San Sebastian Cheesecake', price: 195, qty: 1 }
    ],
    total: 265.00,
    status: 'new',
    createdAt: new Date(Date.now() - 15 * 60 * 1000).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }),
    timestamp: Date.now() - 15 * 60 * 1000
  },
  {
    id: 'ord_1002',
    orderType: 'pickup',
    customerName: 'Zeynep Kaya',
    phone: '0544 987 65 43',
    address: '20 Dakika Sonra Gelip Alacağım',
    orderNote: 'Kahveler bol köpüklü ve sıcak olsun lütfen.',
    paymentMethod: 'cash',
    paymentMethodName: 'Kapıda Nakit',
    items: [
      { id: 'latte', name: 'Caffè Latte', price: 110, qty: 2 },
      { id: 'croissant', name: 'Fransız Tereyağlı Kruvasan', price: 120, qty: 1 }
    ],
    total: 340.00,
    status: 'preparing',
    createdAt: new Date(Date.now() - 40 * 60 * 1000).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }),
    timestamp: Date.now() - 40 * 60 * 1000
  }
];

class Store {
  constructor() {
    this.checkCacheReset();
    this.areas = this.load('yk_areas', DEFAULT_AREAS);
    this.tables = this.load('yk_tables', INITIAL_TABLES);
    this.products = this.initProducts();
    this.save('yk_products', this.products);
    this.adisyons = this.load('yk_adisyons', {});
    this.calls = this.load('yk_calls', []);
    this.eventRequests = this.load('yk_event_requests', INITIAL_EVENT_REQUESTS);
    this.onlineOrders = this.load('yk_online_orders', INITIAL_ONLINE_ORDERS);
    this.cart = this.load('yk_cart', []);
    this.isOrderingEnabled = this.load('yk_ordering_enabled', false);
    this.wifiCode = 'Yesilkose2026';
    this.categories = this.load('yk_categories', [
      { id: 'sicak-iceceekler', name: 'Sıcak İçecekler', emoji: '☕' },
      { id: 'soguk-icecekler', name: 'Soğuk İçecekler', emoji: '🥤' },
      { id: 'tatlilar', name: 'Tatlılar', emoji: '🍰' },
      { id: 'kahvaltiliklar', name: 'Kahvaltılıklar', emoji: '🍳' }
    ]);

    window.addEventListener('storage', () => this.syncFromStorage());
    this.cloudSyncPromise = this.initCloudSync();
  }


  checkCacheReset() {
    const STORE_VERSION = 'v1.0.6_tables';
    const savedVersion = localStorage.getItem('yk_store_version');
    const urlParams = new URLSearchParams(window.location.search);
    const forceReset = urlParams.has('reset') || urlParams.has('clean');

    if (savedVersion !== STORE_VERSION || forceReset) {
      console.log('🔄 Outdated state detected. Clearing localStorage cache...');
      localStorage.removeItem('yk_products');
      localStorage.removeItem('yk_tables');
      localStorage.removeItem('yk_adisyons');
      localStorage.removeItem('yk_calls');
      localStorage.setItem('yk_store_version', STORE_VERSION);
    }
  }


  hardReset() {
    console.log('🧹 Hard resetting application state and localStorage...');
    localStorage.clear();
    sessionStorage.clear();
    const STORE_VERSION = 'v1.0.5_fresh';
    localStorage.setItem('yk_store_version', STORE_VERSION);

    this.areas = DEFAULT_AREAS;
    this.tables = INITIAL_TABLES;
    this.products = INITIAL_PRODUCTS;
    this.adisyons = {};
    this.calls = [];
    this.eventRequests = INITIAL_EVENT_REQUESTS;
    this.onlineOrders = [];
    this.cart = [];

    this.save('yk_products', this.products);
    this.save('yk_tables', this.tables);
    this.save('yk_adisyons', this.adisyons);
    this.save('yk_calls', this.calls);
    this.save('yk_event_requests', this.eventRequests);

    window.dispatchEvent(new CustomEvent('store-update', { detail: { key: 'all' } }));
    return true;
  }

  async initCloudSync() {
    if (!isCloudConnected) return;

    // --- Products ---
    const cloudProducts = await fetchCloudProducts();
    if (cloudProducts && cloudProducts.length > 0) {
      // Merge: cloud is authoritative, but keep local custom products not in cloud
      const merged = cloudProducts.map(cp => {
        const local = this.products.find(p => p.id === cp.id);
        return local ? { ...local, ...cp } : cp;
      });
      // Keep any local-only products
      this.products.forEach(lp => {
        if (!merged.some(p => p.id === lp.id)) merged.push(lp);
      });
      this.products = merged;
      this.save('yk_products', this.products);
    } else {
      // First run: push local products to cloud
      this._syncProductsToCloud();
    }

    // --- Categories ---
    const cloudCategories = await fetchCloudCategories();
    if (cloudCategories && cloudCategories.length > 0) {
      this.categories = cloudCategories;
      this.save('yk_categories', this.categories);
    } else {
      // First run: push local categories to cloud
      this._syncCategoriesToCloud();
    }

    // --- Areas ---
    const cloudAreas = await fetchCloudAreas();
    if (cloudAreas && cloudAreas.length > 0) {
      this.areas = cloudAreas;
      this.save('yk_areas', this.areas);
    } else {
      // First run: push local areas to cloud
      this._syncAreasToCloud();
    }

    // --- Tables ---
    const cloudTables = await fetchCloudTables();
    if (cloudTables && cloudTables.length > 0) {
      // Merge status from local (status is live, managed by adisyon)
      const merged = cloudTables.map(ct => {
        const local = this.tables.find(t => t.id === ct.id);
        return local ? { ...ct, status: local.status } : ct;
      });
      // Keep local-only tables
      this.tables.forEach(lt => {
        if (!merged.some(t => t.id === lt.id)) merged.push(lt);
      });
      this.tables = merged;
      this.save('yk_tables', this.tables);
    } else {
      // First run: push local tables to cloud
      this._syncTablesToCloud();
    }

    const cloudEvents = await fetchCloudEventRequests();
    if (cloudEvents) {
      this.eventRequests = cloudEvents;
      this.save('yk_event_requests', this.eventRequests);
    }

    const cloudCalls = await fetchCloudTableCalls();
    if (cloudCalls) {
      this.calls = cloudCalls;
      this.save('yk_calls', this.calls);
    }

    const cloudAdisyons = await fetchCloudAdisyons();
    if (cloudAdisyons) {
      this.adisyons = cloudAdisyons;
      this.save('yk_adisyons', this.adisyons);
    }

    subscribeRealtimeEvents(
      (newCall) => {
        const formatted = {
          id: newCall.id,
          tableId: newCall.table_id,
          tableName: newCall.table_name,
          type: newCall.type,
          deviceId: newCall.device_id,
          timestamp: newCall.timestamp
        };
        if (!this.calls.some(c => c.id === formatted.id)) {
          this.calls.unshift(formatted);
          this.save('yk_calls', this.calls);
          this.playAlertSound();

          if (typeof window !== 'undefined' && window.showToast) {
            window.showToast(`🔔 ${formatted.tableName.toUpperCase()} ${formatted.type === 'waiter' ? 'GARSON ÇAĞIRIYOR!' : 'HESAP İSTİYOR!'}`, 8000);
          }

          if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'granted') {
            try {
              new Notification(formatted.type === 'waiter' ? '🛎️ Yeşilköşe - Garson Çağrısı' : '💰 Yeşilköşe - Hesap İstendi', {
                body: `${formatted.tableName} • ${formatted.timestamp}`,
                icon: './src/assets/images/logo.jpg',
                tag: 'call_' + formatted.id
              });
            } catch (_) {}
          }
        }

      },
      (newEvent) => {
        const formatted = {
          id: newEvent.id,
          fullName: newEvent.full_name,
          phone: newEvent.phone,
          eventType: newEvent.event_type,
          eventTypeName: newEvent.event_type_name,
          eventArea: newEvent.event_area || '',
          date: newEvent.event_date,
          guests: newEvent.guests,
          notes: newEvent.notes,
          status: newEvent.status || 'new',
          createdAt: new Date(newEvent.created_at).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
        };
        if (!this.eventRequests.some(r => r.id === formatted.id)) {
          this.eventRequests.unshift(formatted);
          this.save('yk_event_requests', this.eventRequests);
          this.playAlertSound();

          // Dispatch event for UI reaction
          window.dispatchEvent(new CustomEvent('new-event-request', { detail: formatted }));

          // Pop-up Toast
          if (typeof window !== 'undefined' && window.showToast) {
            window.showToast(`🔔 YENİ ORGANİZASYON TALEBİ: ${formatted.fullName} (${formatted.guests} Kişi)`, 6000);
          }

          // Browser Desktop Notification (if user granted permission)
          if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'granted') {
            try {
              new Notification('Yeşilköşe Kafe - Yeni Organizasyon Teklifi!', {
                body: `${formatted.fullName} • ${formatted.eventTypeName || 'Etkinlik'} • ${formatted.guests} Kişi\nTarih: ${formatted.date}`,
                icon: './src/assets/images/logo.jpg',
                tag: formatted.id
              });
            } catch (err) {
              console.log('Notification error:', err);
            }
          }
        }
      },
      (adisyonPayload) => {
        if (adisyonPayload.eventType === 'DELETE') {
          const oldTableId = adisyonPayload.old ? adisyonPayload.old.table_id : null;
          if (oldTableId && this.adisyons[oldTableId]) {
            delete this.adisyons[oldTableId];
            this.updateTableStatus(oldTableId, 'empty');
            this.save('yk_adisyons', this.adisyons);
          }
        } else if (adisyonPayload.new) {
          const tableId = adisyonPayload.new.table_id;
          this.adisyons[tableId] = {
            items: adisyonPayload.new.items || [],
            total: Number(adisyonPayload.new.total) || 0
          };
          this.updateTableStatus(tableId, (this.adisyons[tableId].items.length > 0) ? 'occupied' : 'empty');
          this.save('yk_adisyons', this.adisyons);
        }
      }
    );
  }

  // --- CLOUD FIRST-RUN SYNC HELPERS ---
  async _syncProductsToCloud() {
    for (let i = 0; i < this.products.length; i++) {
      await upsertCloudProduct({ ...this.products[i], displayOrder: i });
    }
    console.log('✅ Products synced to Supabase');
  }

  async _syncCategoriesToCloud() {
    for (let i = 0; i < this.categories.length; i++) {
      await upsertCloudCategory({ ...this.categories[i], displayOrder: i });
    }
    console.log('✅ Categories synced to Supabase');
  }

  async _syncAreasToCloud() {
    for (let i = 0; i < this.areas.length; i++) {
      await upsertCloudArea({ ...this.areas[i], displayOrder: i });
    }
    console.log('✅ Areas synced to Supabase');
  }

  async _syncTablesToCloud() {
    for (let i = 0; i < this.tables.length; i++) {
      await upsertCloudTable({ ...this.tables[i], displayOrder: i });
    }
    console.log('✅ Tables synced to Supabase');
  }

  load(key, fallback) {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  save(key, data) {
    try {
      localStorage.setItem(key, JSON.stringify(data));
      window.dispatchEvent(new CustomEvent('store-update', { detail: { key, data } }));
    } catch (e) {
      console.error('Storage Save Error:', e);
    }
  }

  initProducts() {
    const saved = this.load('yk_products', null);
    if (saved && Array.isArray(saved) && saved.length > 0) {
      const merged = INITIAL_PRODUCTS.map(initial => {
        const found = saved.find(p => p.id === initial.id);
        return found ? { ...initial, ...found } : initial;
      });
      saved.forEach(s => {
        if (!merged.some(p => p.id === s.id)) {
          merged.push(s);
        }
      });
      return merged;
    }
    return INITIAL_PRODUCTS;
  }

  syncFromStorage() {
    this.areas = this.load('yk_areas', DEFAULT_AREAS);
    this.tables = this.load('yk_tables', INITIAL_TABLES);
    this.products = this.initProducts();
    this.adisyons = this.load('yk_adisyons', {});
    this.calls = this.load('yk_calls', []);
    this.eventRequests = this.load('yk_event_requests', INITIAL_EVENT_REQUESTS);
    this.onlineOrders = this.load('yk_online_orders', INITIAL_ONLINE_ORDERS);
    this.cart = this.load('yk_cart', []);
    this.isOrderingEnabled = this.load('yk_ordering_enabled', false);
    window.dispatchEvent(new CustomEvent('store-update', { detail: { key: 'all' } }));
  }

  setOrderingEnabled(enabled) {
    this.isOrderingEnabled = !!enabled;
    this.save('yk_ordering_enabled', this.isOrderingEnabled);
  }

  // --- CART & ONLINE ORDERS API ---
  getCart() {
    return this.cart || [];
  }

  addToCart(productId, qty = 1, selectedOption = null) {
    const product = this.products.find(p => p.id == productId);
    if (!product) return { success: false, error: 'Ürün bulunamadı.' };
    if (product.isOutOfStock) return { success: false, error: 'Bu ürün tükenmiştir.' };

    if (!this.cart) this.cart = [];
    const itemName = selectedOption ? `${product.name} (${selectedOption})` : product.name;
    const existing = this.cart.find(i => i.id == productId && i.selectedOption == selectedOption);

    if (existing) {
      existing.qty += qty;
    } else {
      this.cart.push({
        id: product.id,
        name: product.name,
        displayName: itemName,
        price: product.price,
        qty: qty,
        selectedOption: selectedOption || null,
        imageUrl: product.imageUrl || product.image
      });
    }

    this.save('yk_cart', this.cart);
    return { success: true };
  }

  updateCartQty(productId, selectedOption, newQty) {
    if (!this.cart) return;
    if (newQty <= 0) {
      this.removeFromCart(productId, selectedOption);
      return;
    }
    const item = this.cart.find(i => i.id == productId && i.selectedOption == selectedOption);
    if (item) {
      item.qty = newQty;
      this.save('yk_cart', this.cart);
    }
  }

  removeFromCart(productId, selectedOption = null) {
    if (!this.cart) return;
    this.cart = this.cart.filter(i => !(i.id == productId && i.selectedOption == selectedOption));
    this.save('yk_cart', this.cart);
  }

  clearCart() {
    this.cart = [];
    this.save('yk_cart', this.cart);
  }

  getCartTotal() {
    if (!this.cart) return 0;
    return this.cart.reduce((sum, i) => sum + (i.price * i.qty), 0);
  }

  getCartCount() {
    if (!this.cart) return 0;
    return this.cart.reduce((sum, i) => sum + i.qty, 0);
  }

  addOnlineOrder(orderData) {
    const paymentNames = {
      credit_card: 'Kapıda Kredi Kartı',
      cash: 'Kapıda Nakit'
    };

    const newOrder = {
      id: `ord_${Date.now().toString().slice(-6)}`,
      orderType: orderData.orderType || 'delivery',
      customerName: orderData.customerName,
      phone: orderData.phone,
      address: orderData.address || orderData.pickupTime || '',
      orderNote: orderData.orderNote || '',
      paymentMethod: orderData.paymentMethod || 'credit_card',
      paymentMethodName: paymentNames[orderData.paymentMethod] || 'Kapıda Kredi Kartı',
      items: [...orderData.items],
      total: Number(orderData.total) || 0,
      status: 'new',
      createdAt: new Date().toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }),
      timestamp: Date.now()
    };

    this.onlineOrders = [newOrder, ...(this.onlineOrders || [])];
    this.save('yk_online_orders', this.onlineOrders);
    this.clearCart();
    this.playAlertSound();
    return newOrder;
  }

  updateOnlineOrderStatus(orderId, newStatus) {
    const order = (this.onlineOrders || []).find(o => o.id === orderId);
    if (order) {
      order.status = newStatus;
      this.save('yk_online_orders', this.onlineOrders);
    }
  }

  deleteOnlineOrder(orderId) {
    this.onlineOrders = (this.onlineOrders || []).filter(o => o.id !== orderId);
    this.save('yk_online_orders', this.onlineOrders);
  }

  // --- ORGANİZASYON VE ETKİNLİK TEKLİFLERİ API ---
  addEventRequest(data) {
    const eventTypeNames = {
      kina: 'Kına Gecesi',
      nisan: 'Nişan / Söz',
      sunnet: 'Sünnet Töreni',
      dogumgunu: 'Doğum Günü Kutlaması',
      kurumsal: 'Kurumsal Etkinlik / Toplantı',
      diger: 'Özel Davet & Parti'
    };

    const eventAreaNames = {
      'kir-bahcesi': 'Açık Kır Bahçesi (120 Kişi)',
      'kapali-alan': 'Kapalı Alan (100 Kişi)',
      'vip-loca': 'VIP Loca (40 Kişi)',
      'tum-mekan': 'Tüm Mekan / Özel Kiralama'
    };

    const areaText = eventAreaNames[data.eventArea] ? ` [${eventAreaNames[data.eventArea]}]` : '';

    const newReq = {
      id: `req_${Date.now()}`,
      fullName: data.fullName,
      phone: data.phone,
      eventType: data.eventType,
      eventTypeName: (eventTypeNames[data.eventType] || 'Özel Organizasyon') + areaText,
      eventArea: data.eventArea || '',
      date: data.date,
      guests: Number(data.guests) || 0,
      notes: data.notes || '',
      status: 'new',
      createdAt: new Date().toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    };

    this.eventRequests = [newReq, ...(this.eventRequests || [])];
    this.save('yk_event_requests', this.eventRequests);
    saveCloudEventRequest(newReq);
    sendTelegramNotification(newReq);
    this.playAlertSound();
    return newReq;
  }

  updateEventRequestStatus(requestId, newStatus) {
    const req = (this.eventRequests || []).find(r => r && r.id === requestId);
    if (req) {
      req.status = newStatus;
      this.save('yk_event_requests', this.eventRequests);
      updateCloudEventRequestStatus(requestId, newStatus);
    }
  }

  deleteEventRequest(requestId) {
    if (!requestId) return;
    this.eventRequests = (this.eventRequests || []).filter(r => r && r.id !== requestId);
    this.save('yk_event_requests', this.eventRequests);
    deleteCloudEventRequest(requestId);
  }

  // --- ANTI-SPOOFING & AUTHORIZATION API ---
  getDeviceId() {
    let devId = localStorage.getItem('yk_device_id');
    if (!devId) {
      devId = `dev_${Math.random().toString(36).substring(2, 10)}_${Date.now()}`;
      localStorage.setItem('yk_device_id', devId);
    }
    return devId;
  }

  getLockedSession() {
    try {
      const sessionStr = localStorage.getItem('yk_table_session');
      if (!sessionStr) return null;
      const session = JSON.parse(sessionStr);

      // Oturum Süresi Kısıtlaması (2.5 Saat = 150 Dakika)
      // Müşteri kafeden ayrıldıktan sonra açık kalan sekmelerden sahte çağrı yapılamaz
      const MAX_SESSION_DURATION_MS = 2.5 * 60 * 60 * 1000;
      if (session && session.lockedAt) {
        const elapsed = Date.now() - new Date(session.lockedAt).getTime();
        if (elapsed > MAX_SESSION_DURATION_MS) {
          console.log('⌛ Masa oturumu süresi doldu (2.5 saat). Oturum otomatik sıfırlandı.');
          localStorage.removeItem('yk_table_session');
          return null;
        }
      }

      return session;
    } catch (e) {
      return null;
    }
  }

  endLockedSession() {
    localStorage.removeItem('yk_table_session');
    const banner = document.getElementById('tableNoticeBanner');
    if (banner) banner.remove();
  }


  findTable(input) {
    if (!input || !this.tables) return null;
    const q = String(input).trim();
    const qLower = q.toLowerCase();

    // Strateji 1: Birebir token eşleşmesi (örn: m1_oxxvcj)
    let found = this.tables.find(t => t.token === q);
    if (found) return found;

    // Strateji 2: Masa ID eşleşmesi (örn: masa-1 veya masa-12)
    found = this.tables.find(t => t.id === qLower);
    if (found) return found;

    // Strateji 3: İsim eşleşmesi (örn: "masa1" veya "masa 1")
    found = this.tables.find(t => t.name.toLowerCase().replace(/\s+/g, '') === qLower.replace(/[-_]/g, ''));
    if (found) return found;

    // Strateji 4: Token öneki eşleşmesi (örn: "m1_..." -> masa-1)
    const prefixMatch = qLower.match(/^m(\d+)[-_]/);
    if (prefixMatch) {
      const tableNum = prefixMatch[1];
      found = this.tables.find(t => t.id === `masa-${tableNum}`);
      if (found) return found;
    }

    // Strateji 5: "m1" veya "m12" doğrudan masa no
    const shortMatch = qLower.match(/^m(\d+)$/);
    if (shortMatch) {
      const tableNum = shortMatch[1];
      found = this.tables.find(t => t.id === `masa-${tableNum}`);
      if (found) return found;
    }

    // Strateji 6: "masa-X" kalıbı
    const masaMatch = qLower.match(/masa[-_]?(\d+)/);
    if (masaMatch) {
      const tableNum = masaMatch[1];
      found = this.tables.find(t => t.id === `masa-${tableNum}`);
      if (found) return found;
    }

    return null;
  }

  async lockTableSession(tokenInput) {
    if (!tokenInput) return { success: false, error: 'Geçersiz veya eksik QR Kod parametresi.' };
    const rawToken = String(tokenInput).trim();

    // 1. Bulut senkronizasyonu sürüyorsa tamamlanmasını bekle
    if (this.cloudSyncPromise) {
      try { await this.cloudSyncPromise; } catch (_) {}
    }

    let table = this.findTable(rawToken);

    // 2. Bellekte bulunamadıysa Supabase veritabanından doğrudan sorgula
    if (!table && supabase) {
      try {
        const { data: tData } = await supabase.from('tables').select('*').eq('token', rawToken);
        if (tData && tData.length > 0) {
          const t = tData[0];
          table = { id: t.id, name: t.name, areaId: t.area_id, status: t.status || 'empty', token: t.token };
        } else {
          const { data: idData } = await supabase.from('tables').select('*').eq('id', rawToken);
          if (idData && idData.length > 0) {
            const t = idData[0];
            table = { id: t.id, name: t.name, areaId: t.area_id, status: t.status || 'empty', token: t.token };
          }
        }
      } catch (_) {}
    }

    if (!table) {
      return { success: false, error: 'Geçersiz veya süresi dolmuş QR Kod.' };
    }

    const session = {
      tableId: table.id,
      tableName: table.name,
      token: table.token,
      deviceId: this.getDeviceId(),
      lockedAt: new Date().toISOString()
    };

    localStorage.setItem('yk_table_session', JSON.stringify(session));
    return { success: true, table, session };
  }

  verifyRequest(targetTableId) {
    const session = this.getLockedSession();
    if (!session) {
      return { verified: false, reason: 'Masaya kilitli aktif bir QR oturumu bulunamadı. Lütfen masanızdaki QR kodu tekrar taratın.' };
    }

    if (session.tableId !== targetTableId) {
      return { verified: false, reason: `Güvenlik Engeli: Cihazınız ${session.tableName} masasına kilitlidir! Başka masa adına işlem yapamazsınız.` };
    }

    const table = this.tables.find(t => t.id === targetTableId);
    if (!table) {
      return { verified: false, reason: 'Masa bulunamadı. Lütfen QR kodu yeniden okutun.' };
    }

    return { verified: true, session, table };
  }


  // --- AREA & TABLE ACTIONS ---
  moveTable(tableId, newAreaId) {
    const table = this.tables.find(t => t.id === tableId);
    if (table) {
      table.areaId = newAreaId;
      this.save('yk_tables', this.tables);
      upsertCloudTable(table).catch(() => {});
    }
  }

  addTable(name, areaId) {
    const newId = `masa-${Date.now().toString().slice(-4)}`;
    const newTable = {
      id: newId,
      name,
      areaId,
      status: 'empty',
      token: generateSecureToken(newId),
      displayOrder: this.tables.length
    };
    this.tables.push(newTable);
    this.save('yk_tables', this.tables);
    upsertCloudTable(newTable).catch(() => {});
  }

  deleteTable(tableId) {
    this.tables = this.tables.filter(t => t.id !== tableId);
    delete this.adisyons[tableId];
    this.save('yk_tables', this.tables);
    this.save('yk_adisyons', this.adisyons);
    deleteCloudTable(tableId).catch(() => {});
  }

  addCategory(name, emoji = '🍽️') {
    const id = name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '') + '-' + Date.now().toString().slice(-4);
    const newCat = { id, name, emoji, displayOrder: this.categories.length };
    this.categories.push(newCat);
    this.save('yk_categories', this.categories);
    upsertCloudCategory(newCat).catch(() => {});
    return id;
  }

  deleteCategory(categoryId) {
    const cat = this.categories.find(c => c.id === categoryId);
    if (!cat) return;
    // Kategoriye ait ürünleri 'Diğer' kategorisine taşı
    this.products.forEach(p => {
      if (p.category === cat.name) {
        p.category = 'Diğer';
        upsertCloudProduct(p).catch(() => {});
      }
    });
    this.categories = this.categories.filter(c => c.id !== categoryId);
    this.save('yk_categories', this.categories);
    this.save('yk_products', this.products);
    deleteCloudCategory(categoryId).catch(() => {});
  }

  renameCategory(categoryId, newName, newEmoji) {
    const cat = this.categories.find(c => c.id === categoryId);
    if (!cat) return;
    const oldName = cat.name;
    // Ürünlerin kategorisini de güncelle
    this.products.forEach(p => {
      if (p.category === oldName) {
        p.category = newName;
        upsertCloudProduct(p).catch(() => {});
      }
    });
    cat.name = newName;
    if (newEmoji) cat.emoji = newEmoji;
    this.save('yk_categories', this.categories);
    this.save('yk_products', this.products);
    upsertCloudCategory(cat).catch(() => {});
  }

  // --- PRODUCT & STOCK ACTIONS ---
  toggleStock(productId) {
    const p = this.products.find(item => item.id == productId);
    if (p) {
      p.isOutOfStock = !p.isOutOfStock;
      this.save('yk_products', this.products);
      upsertCloudProduct(p).catch(() => {});
    }
  }

  updateProduct(productId, updatedFields) {
    const p = this.products.find(item => item.id == productId);
    if (p) {
      Object.assign(p, updatedFields);
      this.save('yk_products', this.products);
      upsertCloudProduct(p).catch(() => {});
      return { success: true, product: p };
    }
    return { success: false, error: 'Ürün bulunamadı.' };
  }

  addProduct(productData) {
    const rawName = (productData.name || 'Yeni Ürün').trim();
    const slug = rawName.toLowerCase()
      .replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ş/g, 's')
      .replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ç/g, 'c')
      .replace(/[^a-z0-9]/g, '-')
      .replace(/-+/g, '-').replace(/^-|-$/g, '');

    const id = productData.id || `${slug || 'urun'}-${Date.now().toString(36).slice(-4)}`;
    const img = productData.imageUrl || productData.image || './src/assets/images/hero-coffee.jpg';

    const newProduct = {
      id,
      name: rawName,
      category: productData.category || 'Diğer',
      price: Number(productData.price) || 0,
      desc: productData.desc || '',
      imageUrl: img,
      image: img,
      isOutOfStock: Boolean(productData.isOutOfStock),
      tags: Array.isArray(productData.tags) ? productData.tags : [],
      options: productData.options || null,
      displayOrder: this.products.length + 1
    };

    this.products.push(newProduct);
    this.save('yk_products', this.products);
    upsertCloudProduct(newProduct).catch(() => {});
    return newProduct;
  }

  deleteProduct(productId) {
    const p = this.products.find(item => item.id == productId);
    if (!p) return { success: false, error: 'Ürün bulunamadı.' };

    this.products = this.products.filter(item => item.id != productId);
    this.save('yk_products', this.products);
    deleteCloudProduct(productId).catch(() => {});
    return { success: true };
  }


  // --- ADİSYON ACTIONS ---
  addItemToAdisyon(tableId, productId, qty = 1, forceAdmin = false, selectedOption = null) {
    if (!forceAdmin) {
      const authCheck = this.verifyRequest(tableId);
      if (!authCheck.verified) {
        return { success: false, error: authCheck.reason };
      }
    }

    const product = this.products.find(p => p.id == productId);
    if (!product) return { success: false, error: 'Ürün bulunamadı.' };
    if (product.isOutOfStock) return { success: false, error: 'Bu ürün tükenmiştir.' };

    if (!this.adisyons[tableId]) {
      this.adisyons[tableId] = { items: [], total: 0 };
    }

    const itemName = selectedOption ? `${product.name} (${selectedOption})` : product.name;
    const existing = this.adisyons[tableId].items.find(i => i.name === itemName);

    if (existing) {
      existing.qty += qty;
    } else {
      this.adisyons[tableId].items.push({
        id: product.id,
        name: itemName,
        price: product.price,
        qty: qty
      });
    }

    this.calculateAdisyonTotal(tableId);
    this.updateTableStatus(tableId, 'occupied');
    this.save('yk_adisyons', this.adisyons);
    saveCloudAdisyon(tableId, this.adisyons[tableId].items, this.adisyons[tableId].total);
    return { success: true };
  }

  removeAdisyonItem(tableId, itemIndexOrId) {
    if (!this.adisyons[tableId] || !this.adisyons[tableId].items) return;
    if (typeof itemIndexOrId === 'number' || (!isNaN(itemIndexOrId) && Number(itemIndexOrId) >= 0 && Number(itemIndexOrId) < this.adisyons[tableId].items.length)) {
      this.adisyons[tableId].items.splice(Number(itemIndexOrId), 1);
    } else {
      this.adisyons[tableId].items = this.adisyons[tableId].items.filter(i => i.id != itemIndexOrId && i.name != itemIndexOrId);
    }
    this.calculateAdisyonTotal(tableId);
    this.save('yk_adisyons', this.adisyons);
    if (this.adisyons[tableId].items.length === 0) {
      deleteCloudAdisyon(tableId);
    } else {
      saveCloudAdisyon(tableId, this.adisyons[tableId].items, this.adisyons[tableId].total);
    }
  }

  closeAdisyon(tableId) {
    delete this.adisyons[tableId];
    this.updateTableStatus(tableId, 'empty');
    this.clearTableCalls(tableId);
    this.save('yk_adisyons', this.adisyons);
    deleteCloudAdisyon(tableId);
  }

  calculateAdisyonTotal(tableId) {
    if (!this.adisyons[tableId]) return;
    const total = this.adisyons[tableId].items.reduce((sum, item) => sum + (item.price * item.qty), 0);
    this.adisyons[tableId].total = total;
  }

  updateTableStatus(tableId, status) {
    const t = this.tables.find(tbl => tbl.id === tableId);
    if (t) {
      t.status = status;
      this.save('yk_tables', this.tables);
    }
  }

  // --- CALL / ALERT ACTIONS ---
  addCall(tableId, type = 'waiter', forceAdmin = false) {
    if (!forceAdmin) {
      const authCheck = this.verifyRequest(tableId);
      if (!authCheck.verified) {
        return { success: false, error: authCheck.reason };
      }
    }

    const call = {
      id: Date.now(),
      tableId,
      tableName: this.tables.find(t => t.id === tableId)?.name || tableId,
      type,
      timestamp: new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' }),
      deviceId: this.getDeviceId()
    };

    this.calls.unshift(call);
    this.save('yk_calls', this.calls);
    saveCloudTableCall(call);
    this.playAlertSound();
    return { success: true };
  }

  clearTableCalls(tableId) {
    this.calls = this.calls.filter(c => c.tableId !== tableId);
    this.save('yk_calls', this.calls);
  }

  dismissCall(callId) {
    this.calls = this.calls.filter(c => c.id !== callId);
    this.save('yk_calls', this.calls);
    deleteCloudTableCall(callId);
  }

  playAlertSound() {
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return;

      // Singleton AudioContext — create once, reuse
      if (!this._audioCtx) {
        this._audioCtx = new AudioContext();
      }
      const audioCtx = this._audioCtx;

      // Resume suspended context (browser autoplay policy)
      const playTones = () => {
        const now = audioCtx.currentTime;

        // Tone 1: E5 (659Hz)
        const osc1 = audioCtx.createOscillator();
        const gain1 = audioCtx.createGain();
        osc1.type = 'triangle';
        osc1.frequency.setValueAtTime(659.25, now);
        gain1.gain.setValueAtTime(0.35, now);
        gain1.gain.exponentialRampToValueAtTime(0.001, now + 0.35);
        osc1.connect(gain1);
        gain1.connect(audioCtx.destination);
        osc1.start(now);
        osc1.stop(now + 0.35);

        // Tone 2: A5 (880Hz)
        const osc2 = audioCtx.createOscillator();
        const gain2 = audioCtx.createGain();
        osc2.type = 'triangle';
        osc2.frequency.setValueAtTime(880, now + 0.2);
        gain2.gain.setValueAtTime(0.4, now + 0.2);
        gain2.gain.exponentialRampToValueAtTime(0.001, now + 0.7);
        osc2.connect(gain2);
        gain2.connect(audioCtx.destination);
        osc2.start(now + 0.2);
        osc2.stop(now + 0.7);
      };

      if (audioCtx.state === 'suspended') {
        audioCtx.resume().then(playTones).catch(e => console.log('Audio resume failed:', e));
      } else {
        playTones();
      }
    } catch (e) {
      console.log('Audio alert notification prevented or not supported:', e);
    }
  }

}

export const store = new Store();
